import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { addAssestManagerValidation } from "../../utils/validation";
import * as api from "../../redux/api";
import { toast } from "react-toastify";
import { isYupError, parseYupError } from "../../utils/Yup";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import Loader from "../loaders/Loader";
import DesktopCountryForm from "../Forms/DesktopCountryForm";
import { Country, State, City } from "country-state-city";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  address: "",
  companyName: "",
  companyRole: "",
  userRole: "Asset_Manager",
  mobile: "",
  password: "",
  referralCode: ""
};

const AddAssestMnager = ({ handleClose, open, user }) => {
  const [eye, setEye] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(initialState);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [dialCode, setDialCode] = useState("91");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [selectedCity, setSelectedCity] = useState("");
  const [countryName, setCountryName] = useState("India");
  const [stateName, setStateName] = useState("");
  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      setForm((prevForm) => ({
        ...prevForm,
        referralCode: user?.meta?.referralCode
      }));
    }
  }, [user]);

  const handleCloseModal = () => {
    handleClose();
    setForm((prevForm) => ({
      ...initialState,
      referralCode: prevForm.referralCode
    }));
    setFormError(initialState);
    setStateName("");
    setSelectedCountry("");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    console.log("dshfkjbhdkjf");
    try {
      setIsLoading(true);
      await addAssestManagerValidation.validate(form, {
        abortEarly: false
      });
      // if (!selectedState) {
      //   setFormError({
      //     ...formError,
      //     state: "Please select a state"
      //   });
      //   setIsLoading(false);
      //   return;
      // }
      // if (!selectedCity) {
      //   setFormError({
      //     ...formError,
      //     city: "Please select a city"
      //   });
      //   setIsLoading(false);
      //   return;
      // }
      const payload = {
        ...form,
        dialCode: "+" + dialCode,
        mobile: "+" + dialCode + form.mobile,
        addedBy: "admin",
        state: stateName,
        city: selectedCity,
        country: countryName
      };
      const res = await api.registerAssestManager(payload);
      console.log(res, "response");
      console.log(payload, "payload data");
      if (res.status === 200 || res.status === 201) {
        toast.success("Created Successfully");
        handleCloseModal();
      } else {
        toast.error(res?.error?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error, "errrro");
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else if (error.response && error.response.data) {
        toast.error(error.response.data.message || "An error occurred");
      } else {
        console.log(error, "error");
        toast.error("Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    setSelectedState("");
    setSelectedCity("");
    setCities([]);
    const country = Country.getAllCountries().find(
      (c) => c.isoCode === countryCode
    );
    setCountryName(country.name);
    setDialCode(country?.phonecode);
    if (country) {
      const statesList = State.getStatesOfCountry(countryCode);
      setStates(statesList);
    } else {
      setStates([]);
    }
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    setSelectedState(stateCode);
    setSelectedCity("");

    const state = states.find((s) => s.isoCode === stateCode);
    setStateName(state?.name);
    if (state) {
      setFormError((prev) => ({ ...prev, state: "" }));
      const citiesList = City.getCitiesOfState(selectedCountry, stateCode);
      setCities(citiesList);
    } else {
      setCities([]);
    }
  };
  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
    if (e.target.value) {
      setFormError((prev) => ({ ...prev, city: "" }));
    }
  };
  useEffect(() => {
    const statesList = State.getStatesOfCountry("IN");
    setStates(statesList);

    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);
  return (
    <div className="bg-darkest-green-gradient">
      <Dialog
        open={open}
        onClose={handleCloseModal}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form className="bg-darkest-green-gradient">
          <DialogContent dividers={"paper"}>
            <div className="relative bg-darkest-green-gradient">
              <h4 className=" text-center text-white">Add Assest Manager</h4>

              <div className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">First Name</label>
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    autoComplete="off"
                    name="firstName"
                    onKeyDown={(e) => {
                      if (/[^a-zA-Z ]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={handleChange}
                    className="text-input text-black text-12 lg:text-14 border"
                  />
                  {formError.firstName && (
                    <div className="form-eror">{formError.firstName}</div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Last Name</label>
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    name="lastName"
                    onKeyDown={(e) => {
                      if (/[^a-zA-Z ]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    onChange={handleChange}
                    className="text-input text-black border-[#BEBEBE] text-12 lg:text-14 border"
                  />
                  {formError.lastName && (
                    <div className="form-eror">{formError.lastName}</div>
                  )}
                </div>
                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Email Address</label>
                  <input
                    type="text"
                    placeholder="Enter Email"
                    name="email"
                    onChange={handleChange}
                    autoComplete="off"
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                  {formError.email && (
                    <div className="form-eror">{formError.email}</div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <div className="input_field relative">
                    <label className="mb-2 block text-white">Password</label>
                    <div className="flex items-center">
                      <input
                        type={eye ? "text" : "password"}
                        placeholder="Password"
                        name="password"
                        onChange={handleChange}
                        autoComplete="off"
                        className="text-input text-black border border-[#BEBEBE] flex-1 pr-12 text-12 lg:text-14"
                      />
                      <button
                        type="button"
                        className="absolute right-4 top-[68%] transform -translate-y-1/2 cursor-pointer z-0 no-focus-ring"
                        onClick={() => setEye(!eye)}
                      >
                        {eye ? (
                          <AiFillEye className="text-2xl text-theme-text" />
                        ) : (
                          <AiFillEyeInvisible className="text-2xl text-theme-text" />
                        )}
                      </button>
                    </div>
                  </div>
                  {formError.password && (
                    <div className="form-eror">{formError.password}</div>
                  )}
                </div>
                <DesktopCountryForm
                  errorMsg={formError}
                  handleCityChange={handleCityChange}
                  selectedState={selectedState}
                  cities={cities}
                  handleCountryChange={handleCountryChange}
                  selectedCountry={selectedCountry}
                  Country={Country}
                  handleStateChange={handleStateChange}
                  states={states}
                />

                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Address</label>
                  <input
                    type="text"
                    placeholder="House No., Street No...."
                    name="address"
                    autoComplete="off"
                    maxlength="100"
                    onChange={handleChange}
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                  {formError.address && (
                    <div className="form-eror">{formError.address}</div>
                  )}
                </div>
                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Company Name</label>
                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    name="companyName"
                    autoComplete="off"
                    maxlength="100"
                    onChange={handleChange}
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                </div>
                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Company Role</label>
                  <input
                    type="text"
                    placeholder="Enter Your Company Role"
                    name="companyRole"
                    autoComplete="off"
                    maxlength="100"
                    onChange={handleChange}
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                </div>

                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">Mobile Number</label>
                  <div className="relative">
                    <span className="cursor-pointer absolute left-[1px] top-[2px] py-[16.4px] lg:py-[11.4px] px-[6px]  border border-r-black border-y-0 border-l-0 min-w-[50px] h-[45px] flex items-center justify-center">
                      +{dialCode}
                    </span>
                    <input
                      type="text"
                      placeholder="Enter Mobile Number"
                      name="mobile"
                      onChange={handleChange}
                      autoComplete="off"
                      className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14 pl-[60px]"
                    />

                    {formError.mobile && (
                      <div className="form-eror">{formError.mobile}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button
              type="button"
              onClick={handleCloseModal}
              className={`btn btn-danger `}
            >
              Close
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={isLoading}
              className={`btn btn-primary ${
                isLoading
                  ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                  : undefined
              }`}
            >
              {isLoading ? <Loader /> : "Submit"}
            </button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default AddAssestMnager;
